import script from "./TheModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TheModal.vue?vue&type=script&setup=true&lang=js"

import "./TheModal.vue?vue&type=style&index=0&id=31e30dda&scoped=true&lang=scss"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\161\\s\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-31e30dda"]])

export default __exports__